import dayjs from "dayjs";

function buildFutureSchedule(structure) {
  return [
    {
      inspType: "1",
      show7A57Checkbox: false,
      showInterval: false,
      showInspDueDate: false,
      is7A57RequiredValue: null,
      lastInspectionDate: structure?.snbiInspSchedule?.ftPreviousDate,
      inspectionInterval: 0,
      inspectionDueDate: null,
    },
    {
      inspType: "2",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.rouRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.rouPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.rouInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.rouNextDate,
    },
    {
      inspType: "3",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.uwRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.uwPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.uwInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.uwNextDate,
    },
    {
      inspType: "4",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.nstmRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.nstmPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.nstmInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.nstmNextDate,
    },
    {
      inspType: "5",
      show7A57Checkbox: false,
      showInterval: false,
      showInspDueDate: false,
      is7A57RequiredValue: null,
      lastInspectionDate: structure?.snbiInspSchedule?.dmgPreviousDate,
      inspectionInterval: 0,
      inspectionDueDate: null,
    },
    {
      inspType: "6",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.indRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.indPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.indInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.indNextDate,
    },
    {
      inspType: "7",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.osRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.osPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.osInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.osNextDate,
    },
    {
      inspType: "8",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.servRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.servPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.servInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.servNextDate,
    },
    {
      inspType: "9",
      show7A57Checkbox: false,
      showInterval: false,
      showInspDueDate: false,
      is7A57RequiredValue: null,
      lastInspectionDate: structure?.snbiInspSchedule?.scmPreviousDate,
      inspectionInterval: 0,
      inspectionDueDate: null,
    },
    {
      inspType: "P",
      show7A57Checkbox: false,
      showInterval: false,
      showInspDueDate: false,
      is7A57RequiredValue: null,
      lastInspectionDate: structure?.snbiInspSchedule?.probPreviousDate,
      inspectionInterval: 0,
      inspectionDueDate: null,
    },
    {
      inspType: "E",
      show7A57Checkbox: true,
      showInterval: true,
      showInspDueDate: true,
      is7A57RequiredValue: structure?.snbiInspSchedule?.elemRequired,
      lastInspectionDate: structure?.snbiInspSchedule?.elemPreviousDate,
      inspectionInterval: structure?.snbiInspSchedule?.elemInterval,
      inspectionDueDate: structure?.snbiInspSchedule?.elemNextDate,
    },
    {
      inspType: "Q",
      show7A57Checkbox: false,
      showInterval: false,
      showInspDueDate: false,
      is7A57RequiredValue: null,
      lastInspectionDate: structure?.snbiInspSchedule?.qaPreviousDate,
      inspectionInterval: 0,
      inspectionDueDate: null,
    },
  ];
}

// Takes in an array of objects that contain two fields, and
// returns the "Next Inspection Type" (e.g. 2E) for the given list.
// It does this by grouping our next dates by month-year, and then
// concatenates the inspTypes together using the earliest one for our
// next inspection date
// Expects an array of objects that looks like:
// [
//  obj1: {
//      inspectionDueDate: 1901-01-01,
//        inspType: "E"
//      },
//    obj2: {
//      inspectionDueDate: 1901-01-02,
//      inspType: "2"
//    },
//  etc.......
//  ]
function calculateNextInspType(arrayOfInspections) {
  let nextTypeMap = new Map();
  let firstOfMonthArray = [];
  let targetDate;
  for (const entry of arrayOfInspections ?? []) {
    // only attempt if we have a valid inspection due date
    if (entry.inspectionDueDate) {
      // extract our date set to the first day of the month
      // along with a string of format MM-YYYY to use as a key for the map
      let firstOfMonthDate = dayjs(entry.inspectionDueDate).startOf("month");
      let firstOfMonthKey = firstOfMonthDate.format("MM-YYYY");

      // push our dayJS object into an array for sorting later to find
      // the earliest date
      firstOfMonthArray.push(firstOfMonthDate);

      // If our map has an existing copy of the key, append the inspType to the end
      // of the existing entry. If not, insert it
      if (nextTypeMap.has(firstOfMonthKey)) {
        nextTypeMap.set(firstOfMonthKey, nextTypeMap.get(firstOfMonthKey) + entry.inspType);
      } else {
        nextTypeMap.set(firstOfMonthKey, entry.inspType);
      }
    }
  }
  // Find the earliest date from all our entries
  if (firstOfMonthArray.length > 0) {
    firstOfMonthArray.sort((a, b) => a.diff(b));
    targetDate = firstOfMonthArray[0];
  }
  return nextTypeMap.get(targetDate?.format("MM-YYYY"));
}
export { buildFutureSchedule, calculateNextInspType };
